<div class="content-confirmation">
  <h1 mat-dialog-title> {{ data.title }}</h1>
  <app-divider></app-divider>
  <div mat-dialog-content>
    <p> {{ data.menssagem }} </p>
  </div>
  <app-divider></app-divider>
  <div class="form-footer">
    <button mat-button class="confirm" (click)="onConfirm(true)"> 
      Sim, desejo excluir</button>
    <button mat-button class="unconfirm" (click)="onConfirm(false)">
      Não, desejo sair</button>
  </div>
</div>
